export const iconFontAwesomeMaritimeFishFins = (
	<i className="fa-solid fa-fish-fins"></i>
);
